<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg"></div>
    <!-- /.background-image-search -->

    <base-header class="pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <RecipeList :searchUri="'recipes/getMySharedRecipes'" :binder="this.$store.state.recipes.mySharedRecipes" :payload="{ 'userId': this.$store.state.authentication.user.user.id }" />
    
  </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import RecipeList from '@/views/Recipe/RecipeList.vue';

export default {
  components: {
    RouteBreadCrumb,
    RecipeList
  }
};
</script>
<style>
</style>